export default __webpack_public_path__ + "svg/banner/face.svg?278ee5d1";